<template>
    <div class="p-9 w-full bottom-0 pb-8 footer">
        <div style="width:65vw; margin:auto;">
            <div class="grid grid-flow-row auto-rows-max sm:grid-col-12 lg:grid-col-4 md:grid-cols-6 gap-4 mb-12">
                <div class="col-span-4 md:col-span-2 mx-5">
                    <span class="font-bold font-weight-bold text-white" style="font-size:16px"> Support </span>
                    <ul class="ps-0">
                        <li class="text-white text-md font-bold my-3 list-none">
                            <div class="flex items-center mt-2">
                                <a :href="routes.who_we_are" target="_blank" class="footer-menu">
                                    About us
                                </a>
                            </div>
                        </li>
                        <li class="text-white text-md font-bold my-3 list-none">
                            <div class="flex items-center mt-2">
                                <a :href="routes.contact_us" target="_blank" class="footer-menu">
                                    Contact us
                                </a>
                            </div>
                        </li>
                        <li class="text-white text-md font-bold my-3 list-none">
                            <div class="flex items-center mt-2">
                                <a :href="routes.help" target="_blank" class="footer-menu">
                                    Help
                                </a>
                            </div>
                        </li>
                        <li class="text-white text-md font-bold my-3 list-none">
                            <div class="flex items-center mt-2">
                                <a :href="routes.blog" target="_blank" class="footer-menu">
                                    Blog
                                </a>
                            </div>
                        </li>

                    </ul>
                </div>

                <div class="col-span-4 md:col-span-2 mx-5">
                    <span class="font-bold font-weight-bold text-white" style="font-size:16px"> Contacts </span>
                    <ul class="ps-0">
                        <li class="text-white text-md font-bold my-3 list-none">
                            <div class="flex items-center mt-2">
                                <span class="text-white footer-menu">
                                    <address>
                                        Canada <br>
                                        300 Ray Lawson Blvd, Suite 407, Brampton, ON, L6Y 5H5, +16478777232
                                    </address>
                                </span>
                            </div>
                        </li>

                        <li class="text-white my-3 list-none">
                            <div class="row justify-center">
                                <a href="https://www.youtube.com/channel/UCwA3SjWlgOCc3WkghsQz5YQ" target="_blank" class="inline-flex p-1 rounded-md shadow-md mr-2 text-center self-center hover:shadow-xl transition duration-500 ease-in-out footer-icons bg-red-600" rel="noopener noreferrer nofollow">
                                    <i class="fa fa-youtube-play"></i>
                                </a>

                                <a href="https://www.instagram.com/happy_trainers/" target="_blank" class="inline-flex p-1 rounded-md shadow-md mr-2 text-center self-center hover:shadow-xl transition duration-500 ease-in-out footer-icons instagram-bg" rel="noopener noreferrer nofollow">
                                    <i class="fa fa-instagram"></i>
                                </a>

                                <!--
                                <a href="" target="_blank" class="inline-flex p-1 rounded-md shadow-md mr-2 text-center self-center hover:shadow-xl transition duration-500 ease-in-out footer-icons bg-blue-600" rel="noopener noreferrer nofollow">
                                    <i class="fa fa-telegram"></i>
                                </a>

                                <a href="" target="_blank" class="inline-flex p-1 rounded-md shadow-md mr-2 text-center self-center hover:shadow-xl transition duration-500 ease-in-out footer-icons bg-blue-700" rel="noopener noreferrer nofollow">
                                    <i class="fa fa-twitter"></i>
                                </a>

                                <a href="" target="_blank" class="inline-flex p-1 rounded-md shadow-md mr-2 text-center hover:shadow-xl transition duration-500 ease-in-out self-center footer-icons bg-indigo-700" rel="noopener noreferrer nofollow">
                                    <i class="fa fa-linkedin"></i>
                                </a>
                                -->
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="col-span-4 md:col-span-2 mx-5">
                    <span class="font-bold font-weight-bold text-white" style="font-size:16px">  </span>
                    <ul class="ps-0">
                        <li class="text-white text-md font-bold my-3 list-none">
                            <div class="flex items-center mt-2">
                                <a :href="routes.terms_of_service" target="_blank" class="footer-menu">
                                    Terms of Service
                                </a>
                            </div>
                        </li>
                        <li class="text-white text-md font-bold my-3 list-none">
                            <div class="flex items-center mt-2">
                                <a :href="routes.privacy_policy" target="_blank" class="footer-menu">
                                    Privacy Policy
                                </a>
                            </div>
                        </li>
                        <!--                        <li class="text-white text-md font-bold my-3 list-none">
                                                    <div class="flex items-center mt-2">
                                                        <a :href="routes.privacy_policy" target="_blank" class="footer-menu">
                                                            Cookie Policy
                                                        </a>
                                                    </div>
                                                </li>-->
                        <li class="text-white text-md font-bold my-3 list-none">
                            <div class="flex items-center mt-2">
                                <span class="fa fa-copyright mx-1" style="font-size: 18px;"></span>
                                <span class="footer-menu text-white">
                                    2025 by Happy Trainers
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Link} from '@inertiajs/inertia-vue3'
import myMixin from "@/myMixin";

export default {
    mixins: [myMixin],
    name: "Footer",
    components: {Link}
}
</script>

<style scoped>
.footer {
    background: #384047;
}

.footer a {
    color: #e3e5e6;
}

.footer-icons {
    font-size: 1.2rem;
}

.instagram-bg {
    background: #f09433;
    background: -moz-linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
    background: -webkit-linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
    background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f09433', endColorstr='#bc1888', GradientType=1);
}

</style>
